import { DatePicker } from "antd";
import React from "react";
import styles from "../styles.module.scss";

export default function CustomDatePicker({
  title,
  required = false,
  placeholder = "-",
  value,
  onChange,
  disabled = false,
  style,
}) {
  return (
    <div className="d-flex flex-column gap-1">
      {title && (
        <div className={styles.title}>
          {required && <span>*</span>}
          {title}
        </div>
      )}

      <DatePicker
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        style={{
          minHeight: 40,
          ...style,
          // width: "100%"
        }}
      />
    </div>
  );
}
